import React, {useEffect} from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

export default function Status(props)
{
    useEffect(() => {
        console.log('props.mnessage: ' + props.message)
        if((props.message).length > 0) { setOpen(true) }
    }, [props.message])

    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };
        return(
            <React.Fragment>
                <Snackbar open={open} autoHideDuration={1200} onClose={handleClose}>
                <Alert onClose={handleClose} severity={props.severity}>
                    {props.message}
                </Alert>
            </Snackbar>
            </React.Fragment>
        );
}